import { render, staticRenderFns } from "./TipsPopup.vue?vue&type=template&id=f69cb982&scoped=true&"
var script = {}
import style0 from "./TipsPopup.vue?vue&type=style&index=0&id=f69cb982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69cb982",
  null
  
)

export default component.exports